import Head from 'next/head'
import Image from 'next/image'
// import styles from '../styles/Home.module.css'
import styles from '../../styles/Home.module.css'

import BaseTemplate from '../../src/layouts/BaseTemplate'
import PatientView from '../../src/view/_public/booking/Patient';

import { PrismaClient } from '@prisma/client'

import superjson from 'superjson';

import { useQuery } from 'react-query';


export default function Patient(props) {
  // const { data, status } = useQuery('users', getUsers, { initialData: props.users })
  // console.log("data", data)
  // console.log("status", status)
  console.log("bookingprops", props)
  
  return (
    <BaseTemplate title="Booking" body={<PatientView />} />
  )
}
